"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Input_1 = __importDefault(require("../Input/Input"));
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const utils_1 = require("../utils");
const styled_1 = __importDefault(require("../utils/styled"));
const StyledInput = styled_1.default(Input_1.default) `
  outline: 1px solid ${({ error, theme }) => (error ? theme.color.error : theme.color.primary)};
  margin: ${({ theme }) => -theme.space.medium}px ${({ theme }) => -theme.space.content}px;
  height: 100%;
  min-height: 0;
  font-family: ${({ theme }) => theme.font.family.code};
  border-radius: 0;
  border-color: transparent;
  background-color: ${({ error, theme }) => (error ? utils_1.setAlpha(0.2)(theme.color.error) : theme.color.white)};
  color: ${({ error, theme }) => (error ? theme.color.error : theme.color.primary)};
  font-weight: ${({ error, theme }) => (error ? theme.font.weight.bold : theme.font.weight.regular)};
  :focus {
    border-color: transparent;
    box-shadow: none;
    outline: 1px solid ${({ error, theme }) => (error ? theme.color.error : theme.color.primary)};
    outline-offset: 0;
  }
  ::placeholder {
    color: inherit;
  }
`;
exports.DataTableInput = (_a) => {
    var { copy } = _a, props = __rest(_a, ["copy"]);
    return (React.createElement(StyledInput, Object.assign({}, props, { errorComponent: ({ errorMessage }) => React.createElement(Tooltip_1.default, { position: "bottom" }, errorMessage), fullWidth: true }, props)));
};
exports.default = exports.DataTableInput;
//# sourceMappingURL=DataTableInput.js.map